import { Alert, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { OperationResult, OperationStatus } from '@/shared/api/operationResult'

interface OperationResultAlertProps {
  result: OperationResult | null | undefined
  /** Yopiladigan qilish — modal ichida odatda kerak emas */
  closable?: boolean
  onClose?: () => void
  /** «Abonent qayta ulanganda kuchga kiradi» izohi — faqat sessiyaga tegadigan amallar uchun */
  partialNote?: boolean
}

/**
 * `status` → antd `Alert` turi.
 *
 * ⚠️ `PARTIAL` → `warning` (SARIQ). Bu butun jadvaldagi eng muhim qator.
 * U "xato" (qizil) bo'lsa operator amalni bekor qilingan deb o'ylaydi va
 * qayta bosadi — baza esa allaqachon to'g'ri. "Muvaffaqiyat" (yashil) bo'lsa
 * esa panel YOLG'ON aytadi: abonent hali ham eski tezlikda ishlayapti.
 */
const ALERT_TYPE: Record<OperationStatus, 'success' | 'warning' | 'error'> = {
  OK: 'success',
  PARTIAL: 'warning',
  FAILED: 'error',
}

const TITLE_KEY: Record<OperationStatus, string> = {
  OK: 'operation.okTitle',
  PARTIAL: 'operation.partialTitle',
  FAILED: 'operation.failedTitle',
}

export function OperationResultAlert({
  result,
  closable = false,
  onClose,
  partialNote = true,
}: OperationResultAlertProps) {
  const { t } = useTranslation()
  if (!result) return null

  const type = ALERT_TYPE[result.status]
  // Server matni faqat o'zbekcha — boshqa tilda uning o'rnida tarjima turadi
  const serverLanguage = t('common.langCode', { defaultValue: '' }) === 'uz'

  return (
    <Alert
      type={type}
      showIcon
      closable={closable}
      {...(onClose ? { onClose } : {})}
      message={t(TITLE_KEY[result.status])}
      description={
        <>
          {serverLanguage ? <div>{result.message}</div> : null}
          {!serverLanguage && result.status === 'FAILED' ? <div>{t('operation.failedExplain')}</div> : null}

          {/* PARTIAL uchun QO'SHIMCHA izoh: serverning xabari qisqa bo'lishi
              mumkin, foydalanuvchi esa aynan shu holatda "endi nima
              bo'ladi?" deb so'raydi. Javob doim bir xil — abonent qayta
              ulanganda kuchga kiradi. */}
          {partialNote && result.status === 'PARTIAL' && (
            <Typography.Paragraph type="secondary" style={{ marginBottom: 0, marginTop: 4 }}>
              {t('operation.partialExplain')}
            </Typography.Paragraph>
          )}

          {serverLanguage && result.detail ? (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {result.detail}
            </Typography.Text>
          ) : null}
        </>
      }
    />
  )
}
